import { Box } from "@mui/material";
import {
  type otherSetting,
  type BattleStatusTag,
  WEATHER_EMPTY,
  WEATHER_HARE,
  WEATHER_OOHIDERI,
  WEATHER_RANKIRYUU,
  WEATHER_AME,
  WEATHER_OOAME,
  WEATHER_SUNA,
  WEATHER_YUKI,
  BATTLE_FIELD_EMPTY,
  BATTLE_FIELD_PSYCHO_SAIKO,
  BATTLE_FIELD_EREKI,
  BATTLE_FIELD_MISUTO,
  BATTLE_FIELD_GLASS,
  hasBattleStatus,
  setBattleStatus,
} from "../types/other-setting";

// 後方互換のため、ここからも型・定数を再エクスポート
export type { otherSetting, BattleStatusTag } from "../types/other-setting";
export {
  WEATHER_EMPTY,
  WEATHER_HARE,
  WEATHER_OOHIDERI,
  WEATHER_RANKIRYUU,
  WEATHER_AME,
  WEATHER_OOAME,
  WEATHER_SUNA,
  WEATHER_YUKI,
  BATTLE_FIELD_EMPTY,
  BATTLE_FIELD_PSYCHO_SAIKO,
  BATTLE_FIELD_EREKI,
  BATTLE_FIELD_MISUTO,
  BATTLE_FIELD_GLASS,
  hasBattleStatus,
  setBattleStatus,
} from "../types/other-setting";

function OtherSetting({
  otherSetting,
  handleSaveOtherSetting,
  canSelectOoame = false,
  canSelectOohidery = false,
  canSelectRankiryuu = false,
}: {
  otherSetting: otherSetting;
  handleSaveOtherSetting: (v: otherSetting) => void;
  canSelectOoame?: boolean;
  canSelectOohidery?: boolean;
  canSelectRankiryuu?: boolean;
}) {
  const handleBattleStatusChange = (status: BattleStatusTag, checked: boolean) => {
    handleSaveOtherSetting(setBattleStatus(otherSetting, status, checked));
  };

  return (
    <Box
      className="pl-4"
      sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 3, flexWrap: 'wrap' }}
    >
      {/* Weather Selection */}
      <Box className="flex items-center justify-start py-1" sx={{ display: 'flex' }}>
        <select
          value={otherSetting.weather}
          onChange={(e) =>
            handleSaveOtherSetting({
              ...otherSetting,
              weather: Number(e.target.value),
            })
          }
          className="h-8 w-[14ch] rounded border border-gray-300 bg-white px-2 text-[0.8rem] shadow-sm focus:border-sky-500 focus:outline-none focus:ring-2 focus:ring-sky-200 ml-2"
        >
          <option value={WEATHER_EMPTY}>天候を選択</option>
          <option value={WEATHER_HARE}>はれ</option>
          <option value={WEATHER_OOHIDERI} disabled={!canSelectOohidery}>おおひでり</option>
          <option value={WEATHER_RANKIRYUU} disabled={!canSelectRankiryuu}>らんきりゅう</option>
          <option value={WEATHER_AME}>あめ</option>
          <option value={WEATHER_OOAME} disabled={!canSelectOoame}>おおあめ</option>
          <option value={WEATHER_SUNA}>すなあらし</option>
          <option value={WEATHER_YUKI}>ゆき</option>
        </select>
      </Box>

      {/* Field Selection */}
      <Box className="flex items-center justify-start py-1" sx={{ display: 'flex' }}>
        <select
          value={otherSetting.battle_field}
          onChange={(e) =>
            handleSaveOtherSetting({
              ...otherSetting,
              battle_field: Number(e.target.value),
            })
          }
          className="h-8 w-[18ch] rounded border border-gray-300 bg-white px-2 text-[0.8rem] shadow-sm focus:border-sky-500 focus:outline-none focus:ring-2 focus:ring-sky-200 ml-2"
        >
          <option value={BATTLE_FIELD_EMPTY}>フィールドを選択</option>
          <option value={BATTLE_FIELD_PSYCHO_SAIKO}>サイコフィールド</option>
          <option value={BATTLE_FIELD_EREKI}>エレキフィールド</option>
          <option value={BATTLE_FIELD_MISUTO}>ミストフィールド</option>
          <option value={BATTLE_FIELD_GLASS}>グラスフィールド</option>
        </select>
      </Box>

      {/* Reflector and Light Screen */}
      <Box className="flex items-center justify-start py-1" sx={{ display: 'flex' }}>
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2 }} className="ml-2">
          <label className="flex cursor-pointer select-none items-center gap-1 text-[0.8rem] px-2 py-1">
            <input
              type="checkbox"
              checked={hasBattleStatus(otherSetting, 'reflector')}
              onChange={(e) => handleBattleStatusChange('reflector', e.target.checked)}
              className="h-4 w-4 accent-sky-600"
            />
            リフレクター
          </label>
          <label className="flex cursor-pointer select-none items-center gap-1 text-[0.8rem] px-2 py-1">
            <input
              type="checkbox"
              checked={hasBattleStatus(otherSetting, 'light-screen')}
              onChange={(e) => handleBattleStatusChange('light-screen', e.target.checked)}
              className="h-4 w-4 accent-sky-600"
            />
            ひかりのかべ
          </label>
          <label className="flex cursor-pointer select-none items-center gap-1 text-[0.8rem] px-2 py-1">
            <input
              type="checkbox"
              checked={hasBattleStatus(otherSetting, 'gravity')}
              onChange={(e) => handleBattleStatusChange('gravity', e.target.checked)}
              className="h-4 w-4 accent-sky-600"
            />
            じゅうりょく
          </label>
        </Box>
      </Box>

    </Box>
  );
}

export default OtherSetting;
